/**
 * Frontend-facing ShareToken types — mirrors `ShareTokenView` from
 * `src/modules/share-token/index.ts` but without the branded ID types
 * (kept structural so the web package doesn't import server-side branded
 * types and tangle the build).
 */

export interface ShareTokenItem {
  id: string;
  token: string;
  test_id: string;
  company_id: string | null;
  issued_to_email: string | null;
  label: string | null;
  max_uses: number;
  use_count: number;
  expires_at: string | null;
  issue_certificate: boolean;
  is_embed_anonymous: boolean;
  allowed_embed_domains: string[];
  time_multiplier: number;
  created_at: string;
  revoked_at: string | null;
  direct_url: string;
  embed_url: string | null;
  embed_snippet: string | null;
}

export type ShareTokenStatus = 'active' | 'used' | 'expired' | 'revoked';

export function deriveStatus(t: ShareTokenItem, nowIso: string): ShareTokenStatus {
  if (t.revoked_at !== null) return 'revoked';
  if (t.expires_at !== null && t.expires_at < nowIso) return 'expired';
  if (t.max_uses !== 0 && t.use_count >= t.max_uses) return 'used';
  return 'active';
}
